"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resetPassword } from "@/lib/centra/selectionFunctions";
import { CentraJS } from "@frend-digital/centra-js-client";

export default function useResetPassword() {
  const queryClient = useQueryClient();
  const setNewPassword = useMutation({
    mutationFn: (variables: { newPassword: string; i: any; id: any }) =>
      resetPassword(variables),

    onError: async (error: Error) => {
      return error;
    },

    onSuccess: async (data) => {
      queryClient.invalidateQueries({
        queryKey: ["selection"],
      });
    },
    onSettled: () => {
      CentraJS.resume();
    },
  });

  return { setNewPassword };
}
